export default __webpack_public_path__ + "static/media/943DB5B7-DD2D-4EB1-97CC-B066D0D0D136_1_102_o.722c2a6f.jpeg";